import { useState } from "react";

import { toolbarActions  } from '../../services/EnumsService';
import ToolbarOptionComponent from '../toolbar/ToolbarOptionComponent';
import ToolbarComponent from '../toolbar/ToolbarComponent';
import ProjectResourceModal from './ProjectResourceModal'

export default function ProjectResourceComponent({projectResource}) {
    const [showProjectResourceModal, setShowProjectResourceModal] = useState(false)

    const editProjectResourceCloseAction = (()=>{
        setShowProjectResourceModal(false)
    })
    const editProjectResourceAction = (()=>{
        setShowProjectResourceModal(true)
    })
    const editProjectResourceModal = (<ProjectResourceModal projectResourceId={projectResource.id} closeAction={editProjectResourceCloseAction}></ProjectResourceModal>)
    return (
        <div>
            {showProjectResourceModal && editProjectResourceModal}
            <div key={projectResource.id} className="flex flex-row">
                <ToolbarComponent className='ml-2 mt-1'> 
                    <ToolbarOptionComponent title={'Editar'} size={20} icon={toolbarActions.Edit} clickAction={editProjectResourceAction}/>
                </ToolbarComponent>
                <a href={projectResource.link} rel="noopener" target="_blank">{projectResource.name}</a>
            </div>
        </div>
    )
}